import {
    CoreApiFilterObject,
    FILTER_TYPES,
} from '@/coreApi/filters/coreApiFilterObject'

const FILTER_ID_DETAIL_FILTER = 'dtl'

const coreApiDetailFilters = [
    {
        title: 'detail',
        key: 'detail',
        field_name: 'detail',
        data: [],
    },
]

export const coreApiDetailFilterObject = new CoreApiFilterObject(FILTER_ID_DETAIL_FILTER, FILTER_TYPES.VALUES, coreApiDetailFilters)
